import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { NeonCard, Spinner, EmptyState } from "../../components/Neon";
import { fmtDateTime } from "../../lib/format";

export default function AdminAuditLogs() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/admin/audit-logs").then(({ data }) => setList(data || [])).catch(() => {}).finally(() => setLoading(false)); }, []);
  if (loading) return <Spinner />;

  return (
    <div data-testid="admin-audit-logs">
      <h2 className="font-display uppercase text-2xl text-white">Audit Logs</h2>
      {list.length === 0 ? <div className="mt-4"><EmptyState title="No audit logs yet" subtitle="Admin actions will appear here." /></div> : (
        <NeonCard variant="soft" className="mt-4" innerClassName="p-0">
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left text-[var(--text-muted)] border-b border-white/10"><th className="p-3">When</th><th>Actor</th><th>Action</th><th className="p-3">Details</th></tr></thead>
            <tbody>
              {list.map((l, i) => (
                <tr key={l.id || i} className="border-b border-white/5">
                  <td className="p-3 text-[var(--text-muted)] whitespace-nowrap">{fmtDateTime(l.created_at || l.timestamp)}</td>
                  <td className="text-[var(--neon-cyan)]">{l.actor || l.actor_email || l.user_id || "—"}</td>
                  <td className="text-white">{l.action || l.event}</td>
                  <td className="p-3 text-[var(--text-muted)] font-mono text-xs max-w-[360px] truncate">{typeof l.details === "object" ? JSON.stringify(l.details) : (l.details || l.target || "")}</td>
                </tr>
              ))}
            </tbody>
          </table></div>
        </NeonCard>
      )}
    </div>
  );
}
